<template>
  <tr
    @click="handleRowClick(row)"
    :style="styleRow(row)"
    class="cursor-pointer"
  >
    <td class="px-0" style="padding-left: 10px; padding-right: 0; width: 58px"><span class="text-xs opacity-20">{{ row.id }}</span></td>
    <td><span class="table-inside__responsive-name">{{ row.name }}</span></td>
    <td>
      <span>{{ row.stage === 'fx' || !row.price ? '–' : toCurrency(row.price, currency) }}</span>
    </td>
    <td>
      <span class="table-inside__status" :style="stageStyle(row)">
        {{ stage(row) }}
      </span>
    </td>
  </tr>
</template>

<script>
import Helper from '@/classes/helper'
import Color from '@/classes/color'
import { mapState, mapStores } from 'pinia/dist/pinia'
import { useTasksStore } from '@/stores/tasks'
import { useCompanyStore } from '@/stores/company'
import { useFinStore } from '@/stores/fin'

export default {
  name: 'TaskRow',
  emits: ['row-click'],
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapStores(useTasksStore),
    ...mapState(useCompanyStore, ['hourlyRate']),
    ...mapState(useFinStore, ['currency']),
    allowSelection() {
      return /planning/.test(this.$route.path)
    }
  },
  methods: {
    toCurrency: Helper.toCurrency,
    calcPrice2: Helper.calcPrice2,
    stage({stage}) {
      return this.tasksStore.statusList[stage]['title']
    },
    stageStyle({stage}) {
      let color = this.tasksStore.statusList[stage]['color']
      if (stage === 'ar') {
        return {
          backgroundColor: this.hexToRGBA(color, 0.06),
          color: this.adjustHexColor(color, 90)
        }
      }
      return {
        backgroundColor: this.hexToRGBA(color, 0.15),
        color: this.adjustHexColor(color, 65)
      }
    },
    handleRowClick(item) {
      if (this.allowSelection === true) {
        this.toggleItem(item)
      } else {
        this.$emit('row-click', item)
      }
    },
    toggleItem(item) {
      const index = this.tasksStore.selectedItems.findIndex((i) => i.id === item.id)
      if (index !== -1) {
        // Элемент найден, удаляем его
        this.tasksStore.selectedItems.splice(index, 1)
      } else {
        // Элемент не найден, добавляем его
        this.tasksStore.selectedItems.push(item)
      }
    },
    styleRow(item) {
      if (this.tasksStore.selectedItems.find((i) => i.id === item.id)) {
        return {
          backgroundColor: '#f4f8fc'
        }
      }
      return {}
    },
    hexToRGBA: Color.hexToRGBA,
    adjustHexColor: Color.adjustHexColor,
  }
}
</script>
